import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';

export const ChartInfoTooltip = () => {
  const { t } = useTranslation(['dashboard']);
  return (
    <Tooltip title={`${t('chartInfo')}`} arrow placement='top'>
      <InfoOutlined fontSize='small' sx={{ ml: 1, mt: -0.7, color: Colors.ColorBox.Blue }} />
    </Tooltip>
  );
};
